module.exports = __webpack_public_path__ + "img/fb-box.ec3f7e74.svg";